import React from 'react'
import Layout from '../Layout'
import PostAuctio from '../../../utils/CommonFunctionality/PostAuction'
const PostAuction = (props) => {
    return (
        <>
            <Layout props={props}>
                <div className="postProductContainer">
                    <PostAuctio
                        defaultCountryCode={224}
                        low_and_high_est={1}
                        theme={'multiseller_two'}
                        local_pickup_text={'Free Shipping'}
                        validationScroll={true}
                    />
                </div>
            </Layout>
        </>
    )
}

export default PostAuction
